export const currency = (value) => {
  const amount = Number(value || 0);
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0
  }).format(amount);
};

export const date = (value) => {
  if (!value) return '-';
  return new Intl.DateTimeFormat('es-CL').format(new Date(value));
};

export const dateTime = (value) => {
  if (!value) return '-';
  return new Intl.DateTimeFormat('es-CL', {
    dateStyle: 'short',
    timeStyle: 'short'
  }).format(new Date(String(value).replace(' ', 'T')));
};

export const time = (value) => {
  if (!value) return '-';
  const raw = String(value).includes(' ') ? String(value).split(' ')[1] : String(value);
  return raw.slice(0, 5);
};

export const toInputDateTime = (value) => {
  if (!value) return '';
  return String(value).replace(' ', 'T').slice(0, 16);
};

export const fromInputDateTime = (value) => {
  if (!value) return '';
  return String(value).replace('T', ' ') + ':00';
};

export const downloadCsv = (filename, rows = []) => {
  if (!rows.length) return;

  const columns = Object.keys(rows[0]);
  const escape = (cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`;
  const csv = [
    columns.join(','),
    ...rows.map((row) => columns.map((column) => escape(row[column])).join(','))
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
